import React from 'react'

export const ForUniversity = () => {
  return (
   <>
       <div> For University</div>
   </>
  )
}
